import { defineStore } from "pinia";

type State = {
	urlParameters: Record<string, string>;
	isAboveAge: boolean;
	state: string | undefined;
	trackingDomain: string;
	pu: string | undefined;
};

export const useStore = defineStore("main", {
	state: (): State => {
		return {
			urlParameters: {
				orientation: "straight",
				lang: "us-en",
			},
			isAboveAge: false,
			state: undefined,
			trackingDomain: "trk.fcktht.com",
			pu: undefined,
		};
	},
	// persist: true,
});
